module.exports = __webpack_public_path__ + "img/air-force.5d6bf162.png";